/**
 * Authentication Service
 * Handles user authentication and profile management
 */

import apiClient from "./api";

class AuthService {
  /**
   * Get current user profile
   * This endpoint auto-creates user on first login
   * @returns {Promise<Object>} User profile data
   */
  async getMe() {
    const response = await apiClient.get("/auth/me");
    
    if (!response.success) {
      throw new Error(response.message || "Failed to get user profile");
    }
    
    return response.data;
  }

  /**
   * Check if user has admin privileges
   * @param {Object} user - User object
   * @returns {boolean}
   */
  isAdmin(user) {
    return user?.role === "admin" || user?.role === "super_admin";
  }

  /**
   * Check if user has super admin privileges
   * @param {Object} user - User object
   * @returns {boolean}
   */
  isSuperAdmin(user) {
    return user?.role === "super_admin";
  }

  /**
   * Check if user is a manager
   * @param {Object} user - User object
   * @returns {boolean}
   */
  isManager(user) {
    return user?.role === "manager";
  }
}

export const authService = new AuthService();
export default authService;
